import { Grid, Image, Skeleton } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { H1, P3 } from "../../components/NormalFonts";
import { useLayout } from "../../context/LayoutContext";
import { useGetNewsDetail } from "../../hooks/News/news.hooks";
import useGetTimezone from "../../hooks/Timezone/timezone.hooks";
import { ContentWrapper } from "../../layouts/components";
import styles from "./styleModule";

const NewsDetail: React.FC = () => {
  const { id: paramId } = useParams<{ id: string }>();
  const { formatSmartDate, toLocalTimezone } = useGetTimezone();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { t } = useTranslation();
  const { getHeaderHeight } = useLayout();
  const [newsId, setNewsId] = useState<string>("");

  const getImagePadding = () => {
    if (screens.md) return "0 116px";
    if (screens.sm) return "0 64px";
    return "0"; // Default for xs or smaller
  };

  const { data: news, isFetching: isFetchingNews } = useGetNewsDetail(
    { id: newsId },
    {
      enabled: !!newsId,
    },
  );

  useEffect(() => {
    const pathname = window.location.pathname;
    console.debug("pathname", pathname);
    switch (pathname) {
      case "/yuzawa-ski":
        setNewsId("38");
        break;
      case "/hoshino-ski":
        setNewsId("2");
        break;
      case "/rusutsu-ski":
        setNewsId("37");
        break;
      case "/teine-ski":
        setNewsId("1");
        break;
      case "/onze-ski":
        setNewsId("15");
        break;
      default:
        setNewsId(paramId || "");
        break;
    }
  }, [paramId]);

  return (
    <ContentWrapper>
      <div
        className={styles.newsWrapper}
        style={
          {
            gap: screens.sm ? 38 : 28,
            "--marginTop": getHeaderHeight(),
          } as React.CSSProperties
        }
      >
        {isFetchingNews ? (
          <Skeleton />
        ) : (
          <>
            <div className={styles.titleWrapper}>
              <H1
                style={{
                  fontSize: screens.md ? 28 : 20,
                  letterSpacing: "1.68px",
                }}
                weight="medium"
                color="#000"
              >
                {news?.title}
              </H1>
              <P3 color="var(--text-content-3)">
                {news?.start_date
                  ? formatSmartDate(toLocalTimezone(news?.start_date))
                  : ""}
              </P3>
            </div>
            <div
              className={styles.imageContainer}
              style={{ padding: getImagePadding() }}
            >
              <Image
                width={"100%"}
                height={"auto"}
                preview={false}
                src={news?.image_url}
                className={styles.image}
              />
            </div>
            <div
              className={styles.content}
              style={{ fontSize: screens.md ? 20 : 16 }}
              dangerouslySetInnerHTML={{ __html: news?.content }}
            />
          </>
        )}
      </div>
    </ContentWrapper>
  );
};

export default NewsDetail;
